import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { AboutContent } from '@backstage/plugin-catalog';
import {
  InfoCard,
  InfoCardVariants,
} from '@backstage/core-components';

/**
 * EntityAboutCardClean - A clean version of EntityAboutCard without action buttons
 * 
 * This component displays the standard About card content (description, owner, 
 * system, type, lifecycle, tags) but removes the "View Source" and "View TechDocs" 
 * action buttons for a cleaner UI.
 * 
 * Use this as a drop-in replacement for EntityAboutCard anywhere in the catalog.
 *
 * @param variant - Controls the layout style of the card. This prop is passed through 
 *                  to the underlying InfoCard's `variant` prop for layout consistency.
 * @remarks The `variant` prop allows you to match the layout of this card with other 
 *          InfoCards in your UI.
 */

interface EntityAboutCardCleanProps {
  /** Controls the layout style of the card (default: 'gridItem') */
  variant?: InfoCardVariants;
}

export const EntityAboutCardClean: React.FC<EntityAboutCardCleanProps> = ({
  variant = 'gridItem',
}) => {
  const { entity } = useEntity();

  return (
    <InfoCard title="About" variant={variant}>
      <AboutContent entity={entity} />
    </InfoCard>
  );
};
